/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePlanRequest
 */
export interface UpdatePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    ownerUserId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePlanRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePlanRequest
     */
    targetEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlanRequest
     */
    budgetTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlanRequest
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the UpdatePlanRequest interface.
 */
export function instanceOfUpdatePlanRequest(value: object): value is UpdatePlanRequest {
    return true;
}

export function UpdatePlanRequestFromJSON(json: any): UpdatePlanRequest {
    return UpdatePlanRequestFromJSONTyped(json, false);
}

export function UpdatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetEndDate': json['targetEndDate'] == null ? undefined : (new Date(json['targetEndDate'])),
        'budgetTotal': json['budgetTotal'] == null ? undefined : json['budgetTotal'],
        'version': json['version'] == null ? undefined : json['version'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function UpdatePlanRequestToJSON(json: any): UpdatePlanRequest {
    return UpdatePlanRequestToJSONTyped(json, false);
}

export function UpdatePlanRequestToJSONTyped(value?: UpdatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'status': value['status'],
        'ownerUserId': value['ownerUserId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetEndDate': value['targetEndDate'] == null ? undefined : ((value['targetEndDate']).toISOString().substring(0,10)),
        'budgetTotal': value['budgetTotal'],
        'version': value['version'],
        'effectTenantId': value['effectTenantId'],
    };
}

